<template>
  <div class="live-box" :style="{background: `url(${liveConfig.short_video_image})`,backgroundSize: 'cover',backgroundRepeat:'no-repeat'}">
    <div class="h4">{{live.count}}</div>
    <div>
        <div class="show" id="show" name="show">直播2场</div>
        <div class="show2" id="show2" name="show2">15:00开播<br>20:00开播<br></div>
    </div>

    <!-- 视频播放区域 -->
    <div class="video-container">
      <video
        v-if="showLiveModal"
        ref="videoPlayer"
        id="player"
        :src="live.url"
        preload="auto"
        webkit-playsinline
        playsinline
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-ignore-metadata="true"
        width="100%"
        height="100%"
        @click="togglePlay"
        @ended="onVideoEnd"
      
      ></video>
      <div v-if="live.url && !showLiveModal">
        <p  style="position: absolute;top: 45%;left: 35%;background-color: #f59c12;color: #fff;border-radius: 10px;padding: 5px;line-height: 40px;font-size: 25px;" @click="goLive">点击进入直播</p>
      </div>
      <div v-if="!live.url ">
        <p  style="position: absolute;top: 45%;left: 35%;background-color: #f59c12;color: #fff;border-radius: 10px;padding: 5px;line-height: 40px;font-size: 25px;" id="zbTipId">暂无直播</p>
      </div>

    </div>

     <!-- 右侧操作按钮 -->
     <div class="side-actions">
      <div class="side-item" v-for="(action, index) in sideActions" :key="index" @click="handleAction(action)">
        <img  :src="action.image" alt=""  class="action-btn">
        <div class="action-text">{{ action.name }}</div>
      </div>
    </div>

    <div class="btn-box"> 
        <div class="btn-input"><input type="text" placeholder="评论" id="pinglun"></div><div class="sbtn" @click="sendMessage">发送</div> 
    </div>


    <!-- 消息弹幕区域 -->
    <div class="barrage-container">
        <div 
        class="barrage-item" 
        v-for="(message, index) in messages" 
        :key="index"
        >
        {{ message }}
        </div>
    </div>

  </div>
</template>
<script>
import {initData,getVideo} from '@/api/api';
export default {
  name: 'App',
  data() {
    return {
      tipsContent:'',
      isAutoPlay: false,
      showNotice: false,
      sideActions: [],
      liveConfig:{
        live_thumb_image:'',
        tip_content:'直播场次:15:00开播,20:00开播,22:00开播',
      },
      live:[],
      messages:[],
      showLiveModal:false,
      params:{
        token:'',
        uid:''
      },

    };
  },
  mounted() {
    this.setInitData();
    this.initLiveConfig();
  
    
    // 防止在iframe中打开
    if (window.top !== window.self) {
      window.top.location.replace(window.self.location.href);
    }
  },
  methods: {
    setInitData(){
       this.params.token=this.getURLParameter('token');
    
        if(!this.params.token || this.params.token=='undefined' || this.params.token==''){
          let token=this.getKey('token');
          if(!token){
            this.params.token=window.localStorage.getItem('token');
          }else{
            this.params.token=token;
            window.localStorage.setItem('token',token);
          }
          
        }
    },
    getURLParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      },
      getKey(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.hash);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      },
    initLiveConfig(){
      let that=this;
      initData(this.params).then(res=>{
        let temp=JSON.parse(that.$decryptData(res));
        console.log(temp);
        that.liveConfig=temp;
        that.live=temp.live;
        that.sideActions=temp.btnlist;
      
        that.$nextTick(() => {
            //that.$refs.videoPlayer.play();
        });
      });
    },
    goLive(){
      let that=this;
      that.showLiveModal=true;
      that.$nextTick(() => {
            that.$refs.videoPlayer.play();
        });

    },
    togglePlay() {
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    randomVideo() {
      //this.video.url = 'https://fsstest2.8818811.net/videos/01.mp4';
      this.$nextTick(() => {
        this.$refs.videoPlayer.play();
      });
      let that=this;
      getVideo().then(res=>{
        let temp=JSON.parse(that.$decryptData(res));
        console.log(temp);
        that.video=temp.video;
        that.$nextTick(() => {
            that.$refs.videoPlayer.play();
        });
      });
    },
    toggleAutoPlay() {
     
      this.hasUserInteracted = true;
    const video = this.$refs.videoPlayer;
    if (video) {
      video.play().catch(err => {
        console.error('播放失败:', err);
      });
      this.isAutoPlay = !this.isAutoPlay;
    }
    },
    onVideoEnd() {
      if (this.isAutoPlay) {
        this.randomVideo();
      }
    },
    initClipboard() {
      
    },
    handleAction(item) {
      if(item.is_w==1){
        window.open(item.url, '_blank');
      }else{
       
        this.$router.push({path:item.url});
      }
      
    },
    // startNoticeTimer() {
    //   setTimeout(() => {
    //     this.showNotice = true;
    //     this.noticeInterval = setInterval(() => {
    //       this.showNotice = true;
    //     }, 10000);
    //   }, 5000);
    // },
    hideNotice() {
      this.showNotice = false;
    },
    sendMessage() {
      const input = document.getElementById('pinglun');
      const message = input.value.trim();
      if (message) {
        this.messages.push(message); // 添加新消息到队列
        input.value = ''; // 清空输入框

        // 移除滚动出视野的消息
        setTimeout(() => {
          this.messages=[];
        }, 3000); // 3秒后移除消息
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.noticeInterval);
  }
};
</script>
<style lang="scss">
.live-box {
  height: 100vh;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  .video-container {
  width: 100%; 
  height: 100vh;
  position: relative;
  .empty{
    background-color: #f59c12;
    color: #fff;
    font-size: 28px;
    font-family: 600;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
}
}
    .h4{
        line-height: 38px;
        height: 38px;
        background: rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        padding: 0 8px;
        border-radius: 100px;
        font-size: 14px;
        z-index: 999;
    }
    // .show{
    //     text-shadow: -1px -1px 0 #d33727, 1px -1px 0 #d33727, -1px 1px 0 #d33727, 1px 1px 0 #d33727, 0px 2px 2px rgba(0, 0, 0, 0.6);
    //     font-size: 30px;
    //     color: #e8e918;
    //     font-family: "微软雅黑";
    //     left: 5%;
    //     top: 8%;
    //     position: absolute;
    // }
    // .show2{
    //     text-shadow: -1px -1px 0 #d33727, 1px -1px 0 #d33727, -1px 1px 0 #d33727, 1px 1px 0 #d33727, 0px 2px 2px rgba(0, 0, 0, 0.6);
    //     font-size: 20px;
    //     color: #e8e918;
    //     font-family: "微软雅黑";
    //     left: 5%;
    //     top: 17%;
    //     position: absolute;
    //     line-height: 28px;
    // }
    .show {
    text-shadow: -1px -1px 0 #e8b200, /* 替换为深黄色 */
                 1px -1px 0 #e8b200,
                -1px 1px 0 #e8b200,
                 1px 1px 0 #e8b200,
                 0px 2px 2px rgba(0, 0, 0, 0.6);
    font-size: 30px;
    color: #ffeb3b; /* 替换为亮黄色 */
    font-family: "微软雅黑";
    left: 5%;
    top: 8%;
    position: absolute;
}

.show2 {
    text-shadow: -1px -1px 0 #e8b200, /* 替换为深黄色 */
                 1px -1px 0 #e8b200,
                -1px 1px 0 #e8b200,
                 1px 1px 0 #e8b200,
                 0px 2px 2px rgba(0, 0, 0, 0.6);
    font-size: 20px;
    color: #ffeb3b; /* 替换为亮黄色 */
    font-family: "微软雅黑";
    left: 5%;
    top: 17%;
    position: absolute;
    line-height: 28px;
}



.side-actions {
  position: fixed;
  margin-right: 20px;
  top: 150px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.side-item{
  display: flex;
    flex-direction: column;
    align-items: center;
}

.action-btn {
  width: 50px;
  height: 50px;
  padding: 0;
  border-radius: 50%;
}
.action-text{
  font-size: 18px;
  color: red;
  font-weight: 600;
}
.btn-box{
    position: absolute;
    bottom: 15px;
    height: 32px;
    display: flex;
    width: 100%;
}
.btn-input{
    flex: 1;
    input{
        height: 100%;
    border: none;
    color: #fff;
    width: 95%;
    padding: 0 10px;
    margin-left: 10px;
    border-radius: 100px;
    background: rgba(0, 0, 0, 0.3);
    }
}
.sbtn {
    cursor: pointer;
    line-height: 32px;
    margin-left: 20px;
    margin-right: 10px;
    padding: 0 15px;
    border-radius: 100px;
    color: #fff;
    background: #f59c12;
}

.barrage-container {
  position: fixed;
  bottom: 100px;
  left: 10px;
  pointer-events: none; /* 禁止鼠标事件 */
  overflow: hidden;
}

.barrage-item {
  position: relative;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-size: 13px;
  padding: 5px 10px;
  border-radius: 15px;
  margin-top: 10px;
  animation: barrage-move 5s ease-out;
}

@keyframes barrage-move {
    from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-50px); /* 控制向上的滚动距离 */
    opacity: 0;
  }
}


</style>